import * as S from "./styles";
import Logo from "assets/hybrid-logo.svg";
import Button from "components/Button";
import Input from "components/Input";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { ErrorAlert } from "components/Alert/Error/ErrorAlert";
import { useAuth } from "contexts/authContext";

export default function LoginScreens() {
  const { authenticateUser } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const location = useHistory();

  async function handleSubmit(event: React.SyntheticEvent) {
    event.preventDefault();

    const response = await authenticateUser({ email, password });
    if (response.status) {
      location.push("/home");
      // window.location.reload();
      return;
    }

    setError(response.message || "E-mail ou senha incorretos");
  }

  return (
    <S.Container>
      <S.ContentContainer>
        <S.TextContainer>
          <img src={Logo} alt="Logo" />
          <h1>Soluções rápidas e efetivas na área de segurança.</h1>
          <p>
            Atendimento de qualidade e excelência 24 horas por dia, 7 dias por
            semana.
          </p>
        </S.TextContainer>
      </S.ContentContainer>
      <S.LoginForm
        onSubmit={(event: React.SyntheticEvent) => handleSubmit(event)}
      >
        <h2>Faça seu login</h2>

        <div>
          <Input
            id="email"
            name="email"
            type="email"
            label="E-mail"
            required={true}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setEmail(event.target.value);
            }}
          />
          <Input
            id="password"
            name="password"
            type="password"
            label="Senha"
            required={true}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setPassword(event.target.value);
            }}
          />
        </div>
        <S.ForgotPasswordContainer>
          <a href="/forget-password">Esqueceu sua senha?</a>
          {error !== "" && <ErrorAlert text={error} />}
        </S.ForgotPasswordContainer>
        <div>
          <Button title="Entrar" />
        </div>
      </S.LoginForm>
    </S.Container>
  );
}
